window.FormDisclaimer = (function($) {
  var obj = {};
  var local = {};

  var registeredTriggers = [];

  obj.disclaimerHandler = function() {
    local.disclaimerHandler();
  };

  var animationLock = false;

  var disclaimerHandler = local.disclaimerHandler = function() {
    $("[data-behavior=form-disclaimer]").exists(function ($disclaimer) {
      $disclaimer.each(function (i, disclaimer) {
        $form = $(disclaimer).closest('form')
        $button = $form.find('input[type=submit]')
        $disclaimer_checkbox = $(disclaimer).find('.disclaimer-check')

        $button.prop('disabled', !$disclaimer_checkbox.is(':checked'));

        $disclaimer_checkbox.on('change', function() {
          $form = $(this).closest('form')
          $button = $form.find('input[type=submit]')

          $button.prop('disabled', !this.checked);
        }).trigger('change')
      });
    });
  }
  return obj;
})($);